import React, { forwardRef } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import IBuildrProps from 'src/utilities/IBuildrProps';

interface IQuestionLinkProps extends IBuildrProps {
    href: string;
    title: string;
}

const QuestionLinkContainer = styled.li<{ ref: React.Ref<any> }>`
    a {
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`

const QuestionLink = forwardRef((props: IQuestionLinkProps, ref) => {
    return (
        <QuestionLinkContainer data-id={props.cmsId} ref={ref} className={classNames(props.editorClassObj, props.className, "mt-2")}>
            <a href={props.href} className="d-block text-dark">{props.title}</a>
        </QuestionLinkContainer>
    )
});

export default QuestionLink;